var map = {
	"./aeus-casino.webp": [
		375,
		375
	],
	"./bigmoney.webp": [
		7349,
		7349
	],
	"./doolphinreef.webp": [
		1164,
		1164
	],
	"./egyptqueen.webp": [
		7656,
		7656
	],
	"./fafafa-gaming.webp": [
		2644,
		2644
	],
	"./fortune-tiger.webp": [
		1962,
		1962
	],
	"./god-of-fortune.webp": [
		6627,
		6627
	],
	"./god-of-wealth.webp": [
		6379,
		6379
	],
	"./golden-fish.webp": [
		6663,
		6663
	],
	"./great-blue.webp": [
		4635,
		4635
	],
	"./king-of-zeus.webp": [
		4308,
		4308
	],
	"./lucky-neko.webp": [
		9815,
		9815
	],
	"./mahjong-coming.webp": [
		8769,
		8769
	],
	"./mahjong-ways-casino.webp": [
		7642,
		7642
	],
	"./mahjong-ways.webp": [
		1930,
		1930
	],
	"./monkey-king-plus.webp": [
		549,
		549
	],
	"./monkey-king.webp": [
		4754,
		4754
	],
	"./monkey-king3.webp": [
		3631,
		3631
	],
	"./rising-fortune.webp": [
		1273,
		1273
	],
	"./sugar-bliss.webp": [
		4097,
		4097
	],
	"./super-ace.webp": [
		8572,
		8572
	],
	"./treasures-of-aztec.webp": [
		7555,
		7555
	],
	"./ways-of-queen.webp": [
		1332,
		1332
	],
	"assets/images/slots/aeus-casino.webp": [
		375,
		375
	],
	"assets/images/slots/bigmoney.webp": [
		7349,
		7349
	],
	"assets/images/slots/doolphinreef.webp": [
		1164,
		1164
	],
	"assets/images/slots/egyptqueen.webp": [
		7656,
		7656
	],
	"assets/images/slots/fafafa-gaming.webp": [
		2644,
		2644
	],
	"assets/images/slots/fortune-tiger.webp": [
		1962,
		1962
	],
	"assets/images/slots/god-of-fortune.webp": [
		6627,
		6627
	],
	"assets/images/slots/god-of-wealth.webp": [
		6379,
		6379
	],
	"assets/images/slots/golden-fish.webp": [
		6663,
		6663
	],
	"assets/images/slots/great-blue.webp": [
		4635,
		4635
	],
	"assets/images/slots/king-of-zeus.webp": [
		4308,
		4308
	],
	"assets/images/slots/lucky-neko.webp": [
		9815,
		9815
	],
	"assets/images/slots/mahjong-coming.webp": [
		8769,
		8769
	],
	"assets/images/slots/mahjong-ways-casino.webp": [
		7642,
		7642
	],
	"assets/images/slots/mahjong-ways.webp": [
		1930,
		1930
	],
	"assets/images/slots/monkey-king-plus.webp": [
		549,
		549
	],
	"assets/images/slots/monkey-king.webp": [
		4754,
		4754
	],
	"assets/images/slots/monkey-king3.webp": [
		3631,
		3631
	],
	"assets/images/slots/rising-fortune.webp": [
		1273,
		1273
	],
	"assets/images/slots/sugar-bliss.webp": [
		4097,
		4097
	],
	"assets/images/slots/super-ace.webp": [
		8572,
		8572
	],
	"assets/images/slots/treasures-of-aztec.webp": [
		7555,
		7555
	],
	"assets/images/slots/ways-of-queen.webp": [
		1332,
		1332
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 217;
module.exports = webpackAsyncContext;